module.exports = __webpack_public_path__ + "static/media/preview1.1ae96ae9.png";